import { useAbility } from "@casl/react";
import { AppShell, Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Can, { AbilityContext } from "@/Can";
import HomeHeader from "@components/HomeHeader/HomeHeader";
import Sidebar from "@components/Sidebar/Sidebar";
import Header from "@components/Tax Pro Only/Header/Header";
import { injectFreshchatBot } from "@/utilities";
import { useAuthStore } from "@utils/stores/authStore";
import { AppRoutes } from "@/constants";
import ClientOverview from "./Panels/ClientOverview/ClientOverview";
import TaxProLinks from "./Panels/TaxProLinks/TaxProLinks";
import TaxProSummary from "./Panels/TaxProSummary/TaxProSummary";
import TaxProTasks from "./Panels/TaxProTasks/TaxProTasks";
import "./TaxProHome.scss";

/**
 *
 * @returns the Home page of the app
 */
const Home = () => {
  const [opened, { toggle }] = useDisclosure();
  const personalInfoString = localStorage.getItem("personalInfo");
  const personalInfo = personalInfoString ? JSON.parse(personalInfoString) : [];

  const ability = useAbility(AbilityContext);
  const { user } = useAuthStore();

  const navigate = useNavigate();

  // Redirect to /home/lite if user is configured for lite home
  useEffect(() => {
    const useLiteHome = user?.useLiteHome ?? true;
    if (useLiteHome) {
      navigate(AppRoutes.homeLite, { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    injectFreshchatBot();

    const button = document.querySelector(".view-more-btn");
    if (button) {
      button.classList.add("subtle-bounce-animation");
      setTimeout(() => {
        button.classList.remove("subtle-bounce-animation");
      }, 1500); // Duration of the subtle bounce animation (1.5 seconds)
    }
  }, [navigate, personalInfo]);

  return (
    <AppShell
      className="home home-page"
      header={{ height: 87 }}
      navbar={{
        width: "15.375rem",
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header className="app-header">
        <Burger
          className="burger"
          opened={opened}
          onClick={toggle}
          hiddenFrom="sm"
          size="sm"
        />
        <Header />
      </AppShell.Header>
      <AppShell.Navbar>
        <Sidebar />
      </AppShell.Navbar>
      <AppShell.Main className="main-container">
        <div style={{ padding: "1rem" }}>
          <HomeHeader firstName={personalInfo?.firstName} />
          <div
            className={`container${
              ability.can("view", "Summary") ? "" : "-member"
            }`}
          >
            <div className="left-section">
              <ClientOverview />
              <div className="tasks-and-links">
                <TaxProTasks />
                <TaxProLinks />
              </div>
            </div>
            <Can I="view" a="Summary">
              <div className={`right-section`}>
                <TaxProSummary />
              </div>
            </Can>
          </div>
        </div>
      </AppShell.Main>
    </AppShell>
  );
};

export default Home;
